import { supabase } from './api'

export const revalidate = 0

function getCompanyId() {
  return localStorage.getItem("companyId");
}


export async function getAllData() {
  const companyId = getCompanyId();
    const { data, error } = await supabase.from('studentbooklistview').select().eq('companyId',companyId);

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }


  export async function getDataWithType(type) {
    const companyId = getCompanyId();
    const { data, error } = await supabase.from('studentbooklistview').select().eq('type',type).eq('companyId',companyId);

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  

  export async function getIdData(id) {
    const { data, error } = await supabase.from('studentbooklistview').select()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getStudentIdData(id) {
    const companyId = getCompanyId();
    const prm = `studentId.eq.${id},studentId.is.null`;
    //.or('studentId.eq.2,studentId.is.null')
    const { data, error } = await supabase.from('studentbooklistview').select()
    //.eq('studentId', id);
    .eq('companyId',companyId)
    .or(prm)
    .order('isRead', { ascending: true })
    .order('title', { ascending: true });
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }


  export async function getStudentIdDataRead(id) {
    //const prm = `studentId.eq.${id},studentId.is.null`;
    //.or('studentId.eq.2,studentId.is.null')
    const { data, error } = await supabase.from('studentbooklistview').select()
    .eq('studentId', id)
    .eq('isRead',true);
    //.or(prm);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }


  export async function addData(adata) {
    const { data, error } = await supabase.from('studentbooklistview').insert(adata).select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function updateData(udata) {
    console.log("udata",udata);
    const { data, error } = await supabase.from('studentbooklistview').update(udata).eq('id', udata.id).select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function deleteIdData(id) {
    const { data, error } = await supabase.from('studentbooklistview').delete()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }